import type { PositionTranslations } from '../data-contract/position-management';

const FALLBACK_LANGUAGE = 'en';

const baseLanguage = (languageTag: string): string => languageTag.replace(/-.*$/, '').toLowerCase();

export const pickLocalizedText = (
    translations: PositionTranslations,
    languageTag: string,
    sourceLanguageTag?: string,
): string | undefined => {
    const entries = Object.entries(translations).filter(([, text]) => text.trim().length > 0);
    const textFor = (tag: string): string | undefined =>
        entries.find(([key]) => key === tag)?.[1] ??
        entries.find(([key]) => baseLanguage(key) === baseLanguage(tag))?.[1];

    return (
        textFor(languageTag) ??
        (sourceLanguageTag === undefined ? undefined : textFor(sourceLanguageTag)) ??
        textFor(FALLBACK_LANGUAGE) ??
        entries[0]?.[1]
    );
};
